(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this._lastY = 0;
    this._isHomepage = false;
    this._ticking = false;
  }

  connectedCallback() {
    this._section = document.querySelector('.section-header');
    this._wrapper = this; // <sticky-header>
    this._isHomepage = this._wrapper.classList.contains('header-wrapper--index');

    this._lastY = window.scrollY;

    window.addEventListener('scroll', this._onScroll.bind(this), { passive: true });
    window.addEventListener('resize', this._onScroll.bind(this));

    this._update(); // initial state
  }

  _onScroll() {
    if (!this._ticking) {
      requestAnimationFrame(() => {
        this._update();
        this._ticking = false;
      });
      this._ticking = true;
    }
  }

  _update() {
    if (!this._section || !this._isHomepage) return;

    const currentY = window.scrollY;
    const scrollingUp = currentY < this._lastY;
    const headerRect = this._section.getBoundingClientRect();

    const headerStillVisible = headerRect.bottom > 0;
    const atTop = currentY <= 0;

    // CASE 1: User is at very top → reset to transparent
    if (atTop) {
      this._reset();
      this._lastY = currentY;
      return;
    }

    // CASE 2: Transparent header still visible → do nothing
    if (headerStillVisible) {
      this._reset();
      this._lastY = currentY;
      return;
    }

    // CASE 3: Header fully out of view AND scrolling up → show sticky
    if (!headerStillVisible && scrollingUp) {
      this._activateSticky();
    }

    this._lastY = currentY;
  }

  _activateSticky() {
    this._section.classList.add('header--scrolled');

    this._wrapper.style.position = 'fixed';
    this._wrapper.style.top = '0';
    this._wrapper.style.left = '0';
    this._wrapper.style.width = '100%';
  }

  _reset() {
    this._section.classList.remove('header--scrolled');

    this._wrapper.style.position = '';
    this._wrapper.style.top = '';
    this._wrapper.style.left = '';
    this._wrapper.style.width = '';
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
